<template>
  <v-card
      class="mx-auto"

      outlined
  >

    <v-img
        class="white--text align-end"
        height="200px"
        :src="match.post.url"
    >

    </v-img>
    <v-card-title class="pb-0">{{match.post.title | truncate(35)}}</v-card-title>
    <v-row align="center">
      <v-col cols="7">
        <v-card-subtitle class="pt-0 pb-0">r/{{ match.post.subreddit }}</v-card-subtitle>
        <v-card-text class="text--primary">
          <div>u/{{match.post.author}}</div>
          <div>{{match.post.created_at | formatTimestamp}}</div>
        </v-card-text>
      </v-col>
      <v-col cols="5"><div class="text-h4">{{match.hamming_match_percent}}%</div></v-col>
    </v-row>




    <v-card-actions>
      <v-btn text color="orange" :href="`https://redd.it/${match.post.post_id}`" target="_blank">View Post</v-btn>
      <v-btn v-if="checkedPost" text color="orange" @click="openCompare">Compare</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from "moment";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
const MemeRepo = RepositoryFactory.get('meme')
export default {
  name: "SearchResultNew",
  props: {
    match: Object,
    bgColor: String,
    checkedPost: Number
  },
  methods: {
    openCompare() {
      let routeData = this.$router.resolve({name: 'Compare', query: {image_one: this.checkedPost.post_id, image_two: this.match.post.post_id}});
      window.open(routeData.href, '_blank');
    },
    createMemeTemplate() {
      MemeRepo.createMemeTemplate({post_id: this.match.post.post_id, dhash_h: this.match.post.dhash_h}, {params: {token: this.$store.getters.token}})
          .then(results => {
            if (results.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: results.data})
            }
            this.$emit('on-alert', {color: 'success', message: "Meme template created"})
          })

    }
  },
  filters: {
    truncate: function(string, value) {
      if (string.length <= value) {
        return string;
      }
      return string.substring(0, value) + '...';
    },
    formatTimestamp(timestamp) {
      return moment.unix(timestamp).format('YY-MM-DD h:mm:ss a');
    },
  }
}
</script>

<style scoped>

</style>
